import PropTypes from 'prop-types';
import React, { useState } from 'react';

import * as S from './Switch.styles';

export const Switch = ({ isDefaultChecked, isDisabled, onClick }) => {
  if (!onClick) {
    return null;
  }

  const [isChecked, setIsChecked] = useState(isDefaultChecked);

  const triggerToggle = () => {
    if (isDisabled) {
      return;
    }

    setIsChecked(!isChecked);
    onClick();
  };

  return (
    <S.StyledSwitch>
      <S.SwitchControl
        isChecked={isChecked}
        isDisabled={isDisabled}
        onClick={isDisabled ? null : triggerToggle}
      >
        <S.SwitchToggle isChecked={isChecked} />
      </S.SwitchControl>
    </S.StyledSwitch>
  );
};

Switch.propTypes = {
  /**
   * Set the toggle button to checked by default.
   */
  isDefaultChecked: PropTypes.bool,
  /**
   * Unable click on the button.
   */
  isDisabled: PropTypes.bool,
  /**
   * Function which is called when the switch is triggered.
   */
  onClick: PropTypes.func.isRequired,
};

Switch.defaultProps = {
  isDefaultChecked: false,
  isDisabled: false,
};
